import React, { useEffect, useState } from 'react';
import ReactDOM from "react-dom/client";
import { DataGrid } from 'devextreme-react';
import { Box } from '@mui/material';
import { IPricelistMasterDetailProps } from 'interfaces/Pricelist/IPricelistMasterDetailProps';
import { IAnalyteDetail } from 'interfaces/Pricelist/IAnalyteDetail';
import { PricelistApis } from 'hooks/apis/PricelistApis';

const PrepAnalysis = (props: IPricelistMasterDetailProps) => {
  const { getPrepAnalysisInfo } = PricelistApis();
  const [error, setError] = useState('');
  const [prepAnalysisInfo, setPrepAnalysisInfo] = useState<IAnalyteDetail | undefined>();
  const [loadingPrepAnalysis, setLoadingPrepAnalysis] = useState<boolean>(true);

  useEffect(() => {
    getPrepAnalysisInfo(props.analysis, props.matrix)
      .then((data) => {
        if (data?.message) {
          setError(data?.message);
        } else {
          setPrepAnalysisInfo(data);
        }
      })
      .catch((e) => setError(e))
      .finally(() => setLoadingPrepAnalysis(false));
  }, [props, getPrepAnalysisInfo]);

  return (
      <Box className="prepAnalysisInfo">
      
      {error && !(prepAnalysisInfo?.AnalyteList?.length > 0) ? <Box className="errorBox">{error}</Box> : null}
      {!error && loadingPrepAnalysis ? <Box className="loadingBox">Loading Prep Analysis Info...</Box> : null}
      
      {!loadingPrepAnalysis && prepAnalysisInfo?.AnalyteList?.length > 0 ?
          <DataGrid
            dataSource={prepAnalysisInfo.AnalyteList}
            rowAlternationEnabled={true}
            showBorders={false}
            wordWrapEnabled={true}
            hoverStateEnabled={false}
            paging={{ enabled: false }}
            headerFilter={{ visible: false }}
            columns={[
              { dataField: "Analyte", dataType: "string" },
              { dataField: "AnalyteAliases", dataType: "string", caption: "Also known as" },
              {
                allowFiltering: false,
                width: 250,
                dataField: "Comments",
                dataType: "string",
                cellTemplate: (container, options) => {
                  const root = ReactDOM.createRoot(container);
                  root.render(<Box className="analysisComments">{options?.data?.Comments}</Box>);
                },
              },
              { dataField: "PqlText", alignment: "center", dataType: "string", caption: "PQL", width: 150 },
              { dataField: "NataPerth", dataType: "boolean", caption: "NATA Per", visible: prepAnalysisInfo.PerthTesting, width: 100 },
              { dataField: "NataSydney", dataType: "boolean", caption: "NATA Syd", visible: prepAnalysisInfo.SydneyTesting, width: 100 },
              { dataField: "NataMelbourne", dataType: "boolean", caption: "NATA Mel", visible: prepAnalysisInfo.MelbourneTesting, width: 100 },
              { dataField: "NataDarwin", dataType: "boolean", caption: "NATA Dar", visible: prepAnalysisInfo.DarwinTesting, width: 100 },
              { dataField: "NataNewcastle", dataType: "boolean", caption: "NATA New", visible: prepAnalysisInfo.NewcastleTesting, width: 100 },
              { dataField: "NataSubcon", dataType: "boolean", caption: "NATA Subcon", visible: prepAnalysisInfo.SubconTesting, width: 100 },
              { dataField: "AnalyteOrder", dataType: "string", sortOrder: "desc", visible: false },
            ]}
          /> : null }
    </Box>
  );
};

export default React.memo(PrepAnalysis);
